import { isNullOrUndefined } from '@bimser/core';
import { Slider } from 'antd';
import Styles from './assets/styles.scss';
import { ISliderMarks, ISliderProps } from './entities';

const BCSlider = (props: ISliderProps) => {
	Styles;
	const tipFormatter = (value: number) => {
		if (props.tipFormatter) {
			return props.tipFormatter(value);
		} else {
			return value || '0';
		}
	};

	const onChange = (value: number | [number, number]) => {
		if (!props.readOnly) {
			props.onChange?.(value);
		}
	};

	return (
		<Slider
			prefixCls={props.prefixCls}
			tooltip={{
				prefixCls: props.tooltipPrefixCls,
				formatter: tipFormatter,
				getPopupContainer: props.getTooltipPopupContainer
			}}
			range={props.range as any}
			min={props.min}
			max={props.max}
			step={!isNullOrUndefined(props.step) && props.step != 0 ? props.step : 1}
			marks={props.marks}
			dots={props.dots}
			value={props.value as any}
			included={props.included}
			disabled={props.disabled}
			vertical={props.vertical}
			defaultValue={props.defaultValue as any}
			onChange={onChange}
			onChangeComplete={props.onAfterChange}
			className={props.className}
			id={props.id}
			style={props.style}
		/>
	);
};
export default BCSlider;

export { ISliderMarks, ISliderProps };
